import fetchdata from '../fetchdata'
import fetchdata_new from '../fetchdata_new'
import fetchapi from '../fetchapi'
// 說明：const api名稱 = (對應組件欄位) => fetchdata(url,formdata參數 ])

// 此架構是每個模組要預先列出對應的api介面的function,並處理傳入參數後呼叫後端api,逐個export,要用的api再逐個import
// 留這架構的用處只有把參數規格寫清楚而已...但其實看後端postman介面就夠了,這裡只是重工而已(要改要看的地方變多而且沒有意義)
// 但是fetchapi這個export出來的物件不能在程式內直接當function呼叫,所以這一層還是得要包
const loginResult = (Param) =>
  fetchdata(Param.module, Param.method,
    {
      'account': Param.account,
      'password': Param.password,
      'apikey': Param.apikey,
      'apiclient': Param.apiclient
    }
  )
const logoutResult = (Param) =>
  fetchdata(Param.module, Param.method,
    {
      'uinqueuid': Param.uinqueuid,
      'session_token': Param.session_token,
      'apikey': Param.apikey,
      'apiclient': Param.apiclient
    }
  )
  
const genericApiResult = (Param) =>
  fetchdata(Param.module, Param.method, Param)

const genericApiResultNew = (Param) =>
  fetchdata_new(Param.module, Param.method, Param)

const genericApi = (Param) =>
    fetchapi(Param)

export {
  loginResult,
  logoutResult,
  genericApiResult,
  genericApiResultNew,
  genericApi
}
